import { useMemo } from 'react';
import { FileMetadata } from '../api/types/cms';
import { useSelector } from 'react-redux';
import { AuthState, Store } from '../store/types';
import config from '../config';

export const useImageBuilder = () => {
    const { auth } = useSelector<Store, AuthState>(state => state.auth);

    return useMemo(() => {
        const buildImageUrl = (
            file?: FileMetadata | string | null,
            width: number | null | undefined = null,
            height: number | null | undefined = null,
            showCorrectVersion: boolean = true,
        ): string => {
            if (!file) return '';
            if (typeof file === 'string') {
                return new URL(
                    `/asset/image/${file}/${width ? Math.round(width) : ''}x${height ? Math.round(height) : ''}?token=${auth?.access_token}`,
                    config.apiHost,
                ).toString();
            }
            return new URL(
                `/asset/image/${file.file_id}/${width ? Math.round(width) : ''}x${height ? Math.round(height) : ''}${file.version && showCorrectVersion ? `?version=${file.version}&token=${auth?.access_token}` : `?token=${auth?.access_token}`}`,
                config.apiHost,
            ).toString();
        };

        const buildFileUrl = (file?: FileMetadata | string | null): string => {
            if (!file) return '';
            if (typeof file === 'string') {
                return new URL(
                    `/asset/file/${file}?token=${auth?.access_token}`,
                    config.apiHost,
                ).toString();
            }
            return new URL(
                `/asset/file/${file.file_id}${file.version ? `?version=${file.version}&token=${auth?.access_token}` : `?token=${auth?.access_token}`}`,
                config.apiHost,
            ).toString();
        };

        const buildDownloadUrl = (
            file?: FileMetadata | string | null,
        ): string => {
            if (!file) return '';
            if (typeof file === 'string') {
                return new URL(
                    `/asset/file/${file}?token=${auth?.access_token}&download=true`,
                    config.apiHost,
                ).toString();
            }
            return new URL(
                `/asset/file/${file.file_id}${file.version ? `?version=${file.version}&token=${auth?.access_token}` : `?token=${auth?.access_token}`}&download=true`,
                config.apiHost,
            ).toString();
        };

        const loadImage = async (srcStr: any) => {
            if (srcStr instanceof File) {
                return srcStr;
            } else {
                return await fetch(srcStr, { mode: 'no-cors' }).then(r =>
                    r.blob(),
                );
            }
        };

        return {
            loadImage,
            buildFileUrl,
            buildDownloadUrl,
            buildImageUrl,
        };
    }, [auth]);
};
